<template>
    <section class="hero is-fullheight">
        <div class="hero-head">
            <commemoria-navbar></commemoria-navbar>
            <div class="container is-fluid">
                <div style="display: flex;" v-if="!loading">
                    <div class="2" style="flex: 1;">
                        <header class="level">
                            <!-- Left side -->
                            <div class="level-left is-flex-shrink-1 is-clipped">
                                <div class="level-item">
                                    <p class="title" style="font-size: 1.5rem;">
                                        <span v-if="this.name">{{ name }}</span>
                                        <span v-else>Contextualisation des lignes du temps</span>
                                    </p>
                                </div>
                            </div>

                            <!-- Right side -->
                            <div class="level-right">
                                <div class="level-item">
                                    <div class="buttons">
                                        <b-tooltip label="Fusionner" type="is-dark" position="is-bottom">
                                            <button class="button is-light" @click="createTimelineModal()">
                                                <span class="icon is-small">
                                                    <i class="fa fa-code-fork fa-lg" aria-hidden="true"></i>
                                                </span>
                                            </button>
                                        </b-tooltip>
                                    
                                        <b-tooltip label="Présentation" type="is-dark" position="is-bottom">
                                            <router-link :to="{name: 'contextualization.present'}" class="button is-light" exact>
                                                <span class="icon is-small">
                                                    <i class="fa fa-television" aria-hidden="true"></i>
                                                </span>
                                            </router-link>
                                        </b-tooltip>
                                    </div>
                                </div>
                            </div>
                        </header>
                        <p class="subtitle" style="font-size: 1rem;">
                            {{ description }}
                        </p>
                    </div>
                </div>
                <div class="meta">
                    <div style="padding: 0.75rem 0;">
                        <router-link :to="{ name: 'timelines.show', params: { id: timeline.id }}" v-for="timeline in timelines" :key="timeline.id" style="margin-right: 8px;">
                            <b-tag :type="'is-'+timeline.color">{{ timeline.title }}</b-tag>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="hero-body" style="padding-top: 0.75em;">
            <div class="container is-fluid">
                <div v-if="!loading">
                    <div>
                        <div class="box" v-if="events.length > 0">
                            <ul class="timeline">
                                <event :data="event" :contextualization="true" v-for="event in events" :key="event.id" :sortable="false"></event>
                            </ul>
                        </div>
                        <p class="has-text-centered" v-if="events.length == 0">
                            Il n'y aucun événement dans cette contextualisation
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="hero-foot">
            <commemoria-footer></commemoria-footer>
        </div>
        <b-loading :active.sync="loading"></b-loading>
    </section>
</template>

<script>
    import eventComponent from '../timelines/_event';
    
    function getTimelineColor(timeline, timelines) {
        return timelines.filter(function (el) {
           return el.id === timeline.id;
        })[0].color;
    }

    export default {
        components: {
            'event': eventComponent
        },

        data() {
            return {
                name: null,
                description: null,
                loading: true,
                timelines: [],
                events: [],
            }
        },

        computed: {
            user() {
                return this.$store.state.account;
            }
        },

        methods: {
            fetchData() {
                var timelines = this.$store.getters.contextualizationTimelines;

                if (timelines.length >= 2) {
                    this.loading = true;
                    
                    var ids = [];

                    timelines.forEach(function(timeline) {
                        ids.push(timeline.id);
                    });

                    axios.post('/api/v1/contextualizations', {
                        'timelines': ids
                    }).then(response => {
                        if (response.data.contextualization.name) {
                            this.name = response.data.contextualization.name;
                        }
                        if (response.data.contextualization.description) {
                            this.description = response.data.contextualization.description;
                        }
                        this.timelines = response.data.contextualization.timelines;

                        this.timelines.forEach(function(timeline, index, array) {
                            let colors = ['context1', 'context2', 'context3', 'context4'];
                            timeline.color = colors[index];
                        });

                        this.events = response.data.contextualization.events;

                        this.events.forEach(function(event,index) {
                            event.timeline.color = getTimelineColor(event.timeline, this.timelines);
                        }, this);
                
                        this.loading = false;

                    }).catch(response => {
                        this.$buefy.toast.open({
                            message: 'Une erreur s\'est produite',
                            type: 'is-danger'
                        });
                        this.loading = false;
                    });
                } else {
                    this.loading = false;
                }
            },

            createTimelineModal() {              
                this.$buefy.modal.open({
                    parent: this,
                    component: require('../../modals/createTimeline').default,
                    props: {
                        authorized: true,
                        events: this.events,
                    },
                    hasModalCard: true
                });
            },
        },

        created() {
            Bus.$on('contextualization.fetch', () => this.fetchData());
            this.fetchData();
        },

        destroyed() {
            Bus.$off('contextualization.fetch');
        },

        breadcrumb() {
            return {
                label: 'Contextualisation des lignes du temps',
                parent: 'home'
            }
        },
    }
</script>

<style scoped>
    .buttons .button, .buttons:last-child {
        margin-bottom: 0;
    }

    .buttons {
        gap: 0.2rem;
    }
</style>